function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg248Samoa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.001,
    style: {
      fill: "#0052B4"
    },
    width: 256,
    height: 255.989
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "187.973,145.805 192.394,159.411 206.699,159.411 195.125,167.818 199.546,181.423    187.973,173.015 176.4,181.423 180.821,167.818 169.248,159.411 183.552,159.411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "116.127,38.953 123.496,61.629 147.336,61.629 128.048,75.641 135.415,98.315    116.127,84.302 96.839,98.315 104.208,75.641 84.919,61.629 108.759,61.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "187.362,62.698 194.73,85.374 218.571,85.374 199.283,99.386 206.65,122.061    187.362,108.046 168.074,122.061 175.442,99.386 156.153,85.374 179.995,85.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "131.055,157.678 138.424,180.354 162.264,180.354 142.975,194.365 150.343,217.04    131.055,203.026 111.767,217.04 119.135,194.365 99.847,180.354 123.687,180.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "68.638,98.315 76.005,120.991 99.847,120.991 80.558,135.003 87.926,157.678    68.638,143.664 49.35,157.678 56.717,135.003 37.429,120.991 61.27,120.991  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg248Samoa);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };